/** Опции моделей OpenAI (как в classic AIAssistant.js, сокращённо по группам). */
export const OPENAI_MODEL_GROUPS: { group: string; items: { value: string; label: string }[] }[] = [
  {
    group: 'GPT-5 / GPT-5.2',
    items: [
      { value: 'gpt-5.2', label: 'gpt-5.2' },
      { value: 'gpt-5.2-pro', label: 'gpt-5.2-pro' },
      { value: 'gpt-5.1', label: 'gpt-5.1' },
      { value: 'gpt-5', label: 'gpt-5' },
      { value: 'gpt-5-pro', label: 'gpt-5-pro' },
      { value: 'gpt-5-mini', label: 'gpt-5-mini' },
      { value: 'gpt-5-nano', label: 'gpt-5-nano' },
      { value: 'gpt-5-chat-latest', label: 'gpt-5-chat-latest' },
    ],
  },
  {
    group: 'GPT-4.1',
    items: [
      { value: 'gpt-4.1', label: 'gpt-4.1' },
      { value: 'gpt-4.1-mini', label: 'gpt-4.1-mini' },
      { value: 'gpt-4.1-nano', label: 'gpt-4.1-nano' },
    ],
  },
  {
    group: 'GPT-4o',
    items: [
      { value: 'gpt-4o', label: 'gpt-4o' },
      { value: 'gpt-4o-mini', label: 'gpt-4o-mini' },
      { value: 'gpt-4o-2024-11-20', label: 'gpt-4o-2024-11-20' },
    ],
  },
  {
    group: 'O-series',
    items: [
      { value: 'o1', label: 'o1' },
      { value: 'o3', label: 'o3' },
    ],
  },
]

export function flattenOpenAIModelOptions(): { value: string; label: string }[] {
  return OPENAI_MODEL_GROUPS.flatMap((g) => g.items)
}
